import ActionTypes from '../actiontypes/global';

const global_state = {
    menu_collapsed : false,
    current_menu: 1,
    menu_cawangan: [],
}

const globalReducer = (state = global_state, action = {}) => {
    if(action.type === ActionTypes.LAYOUT_COLLAPSED){
        return {
            ...state,
            menu_collapsed: !state.menu_collapsed
        }
    }

    if(action.type === ActionTypes.CURRENT_ROUTE){
        return{
            ...state,
            current_menu: action.route_key
        }
    }

    if(action.type === 'CURRENT_SUB'){
        return {
            ...state,
            current_sub: action.sub_key
        }
    }

    if(action.type === 'SENARAI_CAWANGAN'){
        return {
            ...state,
            menu_cawangan: action.payloads
        }
    }

    if(action.type === 'REGISTER_AUTH'){
        return {
            ...state,
            auth: action.payloads
        }
    }
    return state
}

export default globalReducer